// extracted by mini-css-extract-plugin
module.exports = {"LeaderboardAndSummary":"LeaderboardAndSummary_LeaderboardAndSummary__1tWJm","tabs":"LeaderboardAndSummary_tabs__1biwK","selected":"LeaderboardAndSummary_selected__3nMtb"};